import React, { useState } from 'react';
import { TextField, Button, Typography, Container, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const navigate = useNavigate(); // Initialize useNavigate
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  // Pre-defined list of users
  const users = [
    { username: 'admin', password: 'Huc!23admin' },
    { username: 'yiyang', password: 'yiyang2025' },
    { username: 'machao', password: 'machao2025' },
    { username: 'wenxing', password: 'wenxing2025' },
  ];

  const handleLogin = () => {
    // Find user by matching username and password
    const user = users.find((user) => user.username === username && user.password === password);

    if (user) {
      // If user is found, simulate login and navigate to dashboard
      sessionStorage.setItem('isLoggedIn', true); // Store login state (consider a more secure option)
      sessionStorage.setItem('username', username);
      navigate('/dashboard'); // Redirect to the dashboard
      window.location.reload();
    } else {
      // If no matching user, show error message
      setError('Invalid username or password');
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginTop: 8,
        }}
      >
        <Typography variant="h5">Login</Typography>
        <TextField
          label="Username"
          variant="outlined"
          fullWidth
          margin="normal"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <TextField
          label="Password"
          variant="outlined"
          type="password"
          fullWidth
          margin="normal"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        {error && (
          <Typography color="error" variant="body2" style={{ marginTop: 8 }}>
            {error}
          </Typography>
        )}
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={handleLogin}
          style={{ marginTop: 16 }}
        >
          Login
        </Button>
      </Box>
    </Container>
  );
};

export default Login;
